module.exports = __webpack_public_path__ + "media/images/computer_screen-5a2f5b69d2557c8ac275c3d8e20bfe9d.svg";